<template>
    <div>
        <div>
            <div style="display: flex;justify-content: center">
                <div>
                    <el-button icon="el-icon-search" type="primary" @click="initCategorys">
                        刷新
                    </el-button>
                    <el-button type="primary" icon="el-icon-plus" @click="showAddCategoryView">
                        添加分类
                    </el-button>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="categorys"
                    stripe
                    border
                    width="100%"
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.5)"
                    style="width: 100%">
                <el-table-column
                        prop="productCategoryName"
                        align="left"
                        label="分类名称"
                        min-width="50%">
                </el-table-column>
                <el-table-column
                        prop="productNumber"
                        label="产品数量"
                        align="left"
                        min-width="25%">
                </el-table-column>
                <el-table-column
                        min-width="25%"
                        align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showUpdateCategoryView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <el-button @click="deleteCategory(scope.row)" style="padding: 3px" size="mini" type="danger">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: center;">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="dialogAddVisible"
                width="80%">
            <div>
                <el-form :model="category" :rules="rules" ref="categoryAddForm">
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="分类名称:" prop="productCategoryName">
                            <el-input size="mini" style="width: 250px" prefix-icon="el-icon-edit" v-model="category.productCategoryName"
                                      placeholder="请输入分类名称"></el-input>
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAddVisible = false">取 消</el-button>
                <el-button type="primary" @click="doAddCategory(category)">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                :title="title"
                :visible.sync="dialogUpdateVisible"
                width="80%">
            <div>
                <el-form :model="category" :rules="rules" ref="categoryUpdateForm">
                    <el-form-item style="display: flex;justify-content: space-between">
                        <el-form-item label="分类名称:" prop="productCategoryName">
                            <el-input size="mini" style="width: 250px" prefix-icon="el-icon-edit" v-model="category.productCategoryName"
                                      placeholder="请输入分类名称"></el-input>
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogUpdateVisible = false">取 消</el-button>
                <el-button type="primary" @click="doUpdateCategory(category)">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    const axios = require('axios');
    export default {
        name: "ProductCategory",
        inject: ['reload'],
        data() {
            return {
                title: '',
                categorys: [],
                loading: false,
                total: 0,
                page: 1,
                size: 10,
                dialogAddVisible: false,
                dialogUpdateVisible: false,
                category: {
                    productCategoryId: 0,
                    productCategoryName: "",
                    productNumber: "1"
                },
                rules: {
                    productCategoryName: [{required: true, message: '请输入分类名称', trigger: 'blur'}]
                }
            }
        },
        mounted() {
            this.initCategorys();
        },
        watch:{
            total(){
                if(this.total==(this.page-1)*this.size && this.total!=0){
                    this.page-=1;
                    this.initCategorys();//获取列表数据
                }
            }
        },
        methods: {
            showAddCategoryView() {
                this.title = '添加产品分类';
                this.emptyCategory();
                this.dialogAddVisible = true;
            },
            doAddCategory(category) {
                if(category){
                    this.$refs['categoryAddForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/product/category/add", category).then(resp => {
                                if (resp) {
                                    this.dialogAddVisible = false;
                                    this.initCategorys();
                                }
                            })
                        }
                    });
                }
            },
            showUpdateCategoryView(data) {
                this.title = '编辑产品分类信息';
                this.emptyCategory();
                this.category = data;
                this.dialogUpdateVisible = true;
            },
            doUpdateCategory(category) {
                if(category){
                    this.$refs['categoryUpdateForm'].validate(valid => {
                        if (valid) {
                            this.postRequest("/product/category/update", category).then(resp => {
                                if (resp) {
                                    this.dialogUpdateVisible = false;
                                    this.initCategorys();
                                }
                            })
                        }
                    });
                }
            },
            deleteCategory(data) {
                this.$confirm('此操作将永久删除【' + data.productCategoryName + '】, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postRequest("/product/category/delete", data).then(resp => {
                        if (resp) {
                            this.initCategorys();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            emptyCategory() {
                this.category = {
                    productCategoryId: 0,
                    productCategoryName: "",
                    productNumber: "1"
                }
            },
            initCategorys() {
                this.loading = true;
                let url = '/product/category/listByPage?page=' + this.page + '&size=' + this.size;
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.categorys = resp.data;
                        this.total = resp.total;
                    }
                });
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initTemplates();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initTemplates();
            }
        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .templateBottom {
        padding: 10px;
        background-color: #FFFFE0;
        box-sizing: border-box;
    }

    .templateType{
        margin-top: 8px;
    }

    .templateUpload{
        display: flex;
        display: -webkit-flex;
        align-items:center;
        justify-content:center
    }

    .hide .el-upload--picture-card {
        display: none;
    }

</style>
